// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
'use strict';
import { PFixFieldSet } from '../Fields/FieldsImport';
import { FieldsFactory } from '../Factory/FieldsFactory';
import { SubscribeType, SubscriptionSource } from '@shared/utils/Enums/Constants';
export class SubscribeGroup extends PFixFieldSet {
    constructor(pfixFieldSet) {
        super(FieldsFactory.SUBSCRIBE_GROUP_NAME, null, pfixFieldSet);
        // Запоминаем символ, чтобы после прихода респонс
        // мессаджа получить ссылку на инструмент.
        this.Symbol = null;
        // Запоминаем на что мы подписывались,
        // чтобы после прихода респонс мессаджа понять, подписаны мы или нет.
        this.Service = 0;
    }
    getInstrumentId() {
        return this.GetValue(FieldsFactory.FIELD_INSTRUMENT_ID) || 0;
    }
    setInstrumentId(id) {
        this.SetField(FieldsFactory.FIELD_INSTRUMENT_ID, id);
    }
    getTradableInstrumentId() {
        return this.GetValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID) || 0;
    }
    setTradableInstrumentId(id) {
        this.SetField(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, id);
    }
    getRouteId() {
        return this.GetValue(FieldsFactory.FIELD_ROUTE_ID) || 0;
    }
    setRouteId(id) {
        this.SetField(FieldsFactory.FIELD_ROUTE_ID, id);
    }
    getSubscriptionType() {
        return this.GetValue(FieldsFactory.FIELD_SUBSCRIPTION_TYPE) || 0;
    }
    getErrorCode() {
        return this.GetValue(FieldsFactory.FIELD_ERROR_CODE);
    }
    setSubscriptionType(type) {
        this.SetField(FieldsFactory.FIELD_SUBSCRIPTION_TYPE, type);
    }
    getOptionType() {
        return this.GetValue(FieldsFactory.FIELD_OPTION_TYPE) || 0;
    }
    setOptionType(type) {
        this.SetField(FieldsFactory.FIELD_OPTION_TYPE, type);
    }
    isLight() {
        return this.GetValue(FieldsFactory.FIELD_LIGHT_SUBS) || false;
    }
    setLight(light) {
        this.SetField(FieldsFactory.FIELD_LIGHT_SUBS, light);
    }
    setGroupID(groupID) {
        this.SetField(FieldsFactory.FIELD_GROUP_ID, groupID);
    }
    getGroupID() {
        return this.GetValue(FieldsFactory.FIELD_GROUP_ID) || 0;
    }
    setSubscriptionPeriodicity(value) {
        this.SetField(FieldsFactory.FIELD_SUBSCRIPTION_PERIODICITY, value);
    }
    setDataSource(source) {
        if (source !== SubscriptionSource.DATASOURCE) {
            return;
        }
        this.SetField(FieldsFactory.FIELD_IS_DATA_SOURCE, true);
    }
    setTargetTradableId(targetTradableId, source, subscribeType) {
        if (source !== SubscriptionSource.DATASOURCE) {
            return;
        }
        if (subscribeType !== SubscribeType.SUBSCRIBE) {
            return;
        }
        if (!targetTradableId) {
            return;
        }
        this.SetField(FieldsFactory.FIELD_TARGET_TR_INSTR_ID, targetTradableId);
    }
}
